import Phaser from 'phaser';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import SpinePlugin from 'phaser/plugins/spine4.1/dist/SpinePlugin';
import { UpgradeScene } from './scenes/UpgradeScene';
import { AviatorScene } from './scenes/AviatorScene';
import { PhaserGame } from '.';
import { PreloadScene } from './scenes/PreloadScene';

const gameConfig: Phaser.Types.Core.GameConfig = {
  plugins: {
    global: [
      {
        key: 'SpinePlugin',
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        plugin: SpinePlugin,
        start: true,
        mapping: 'spine',
      },
    ],
    scene: [
      {
        key: 'SpinePlugin',
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        plugin: window.SpinePlugin,
        start: true,
        mapping: 'spine',
      },
    ],
  },
  type: Phaser.AUTO,
  width: '200%',
  height: '200%',
  render: {
    pixelArt: false,
    antialias: true,
    antialiasGL: true,
    // antialias: false,
    // antialiasGL: false,
    mipmapFilter: 'NEAREST',
    powerPreference: 'low-power',
  },
  transparent: true,
  autoCenter: 1,
  parent: null,
  fps: {
    target: 30,
    min: 10,
    forceSetTimeOut: true,
    deltaHistory: 5,
  },
  loader: {
    maxParallelDownloads: 2,
    crossOrigin: 'anonymous',
    baseURL: `${window.location.origin}/spine`, // Set the base URL for assets
  },
  scene: [PreloadScene, UpgradeScene, AviatorScene],
};
const GlobalGame = new PhaserGame(gameConfig);

export default GlobalGame;
